module.exports = __webpack_public_path__ + "img/news-bg.69d01c1b.png";